import { Avatar, Zoom } from '@mui/material';
import { PRIVACY_CLASS } from '../../../../../../consts/fullstory';
import { useFormattedYears } from '../../../../../../hooks/formatters';
import { THEME } from '../../../../../../themes';
import { getInitials } from '../../../../../../utils';
import { InitialsAvatar } from '../../../../../Common/InitialsAvatar';

import {
  Bar,
  BarsContainer,
  TooltipBubble,
} from './tenure-chart.styled';

const MIN_BAR_SIZE = 24;
const MAX_BAR_SIZE = 85;

type TenureChartProps = {
  talentName: string,
  talentValue: number,
  companyValue: number,
  talentProfileImage: string,
  companyProfileImage: string,
  companyName: string,
  isEnableAnimation: boolean,
}

export const TenureChart = ({
  talentName,
  talentValue,
  talentProfileImage,
  companyProfileImage,
  companyValue,
  companyName,
  isEnableAnimation,
}:TenureChartProps)
: JSX.Element => {
  const getFormattedYears = useFormattedYears();

  const computeBarHeight = (itemValue: number) => {
    const height = Math.floor(
      (itemValue * (MAX_BAR_SIZE - MIN_BAR_SIZE)) / (companyValue + talentValue)) + MIN_BAR_SIZE;

    return `${height}px`;
  };

  return (
    <BarsContainer >
      <TooltipBubble
        TransitionComponent={ Zoom }
        placement="top-start"
        title={ `${companyName} ${getFormattedYears(companyValue)}` }
      >
        <Bar
          color={ THEME.COLORS.PRIMARY }
          height={ computeBarHeight(companyValue) }
          isEnableAnimation={ isEnableAnimation }
        >
          <Avatar
            style={ {
              width: '16px',
              height: '16px',
              display: 'flex',
              border: '1px solid white',
            } }
            src={ companyProfileImage }
          />
        </Bar>
      </TooltipBubble>
      <TooltipBubble
        TransitionComponent={ Zoom }
        placement="top-start"
        title={ `${talentName} ${getFormattedYears(talentValue)}` }
      >
        <Bar
          color={ THEME.COLORS.ACCENT }
          height={ computeBarHeight(talentValue) }
          isEnableAnimation={ isEnableAnimation }
        >
          <Avatar
            className={ PRIVACY_CLASS.EXCLUDE }
            style={ {
              width: '16px',
              height: '16px',
              display: 'flex',
              border: '1px solid white',
            } }
            src={ talentProfileImage }
          >
            <InitialsAvatar
              alt={ talentName }
              message={ getInitials(talentName) }
              fontSize="8px"
            />
          </Avatar>
        </Bar>
      </TooltipBubble>
    </BarsContainer>
  );
};
